import React from 'react';
import { Helmet } from 'react-helmet';
import { useDarkMode } from '../../contexts/DarkModeContext';
import BlogCard from '../../components/BlogCard/BlogCard';
import AdBanner from '../../components/ADS/AdBanner';
import { slugify } from '../../utils/constants';

function Blog() {
  const { gamesList } = useDarkMode();

  return (
    <div className="px-4 py-4 pb-8">
      <Helmet>
        <title>{'Gaming Blog & News | VibeOfGames'}</title>
        <meta name="description" content="Read the latest gaming news, tips, and game reviews on VibeOfGames Blog." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://vibeofgames.com/blog" />
      </Helmet>

      <AdBanner className="mb-5" />

      {/* Header */}
      <div className="flex items-center gap-3.5 mb-5 p-4 rounded-2xl bg-card-theme border-theme">
        <div className="w-12 h-12 rounded-2xl flex items-center justify-center text-2xl flex-shrink-0 bg-gradient-to-br from-[#22c55e] to-[#059669]">
          📝
        </div>
        <div>
          <h1 className="font-extrabold text-xl m-0 font-sora text-primary-theme">
            Gaming Blog
          </h1>
          <p className="text-xs font-semibold mt-0.5 m-0 text-muted-theme">
            {gamesList?.length || 0} articles
          </p>
        </div>
      </div>

      {/* Blog Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
        {gamesList?.map((_ele, i) => {
          if (!_ele?.name?.en) return null;
          const slug = slugify(_ele.name.en);
          const items = [
            <BlogCard key={`blog-${i}`} id={i} slug={slug} name={_ele.name.en} banner={_ele?.assets?.cover} img={_ele?.assets?.square} _ele={_ele} />
          ];
          if ((i + 1) % 10 === 0) {
            items.push(
              <div key={`ad-${i}`} className="col-span-full">
                <AdBanner />
              </div>
            );
          }
          return items;
        }).flat()}

        {(!gamesList || gamesList.length === 0) && (
          <div className="col-span-full text-center py-16 text-muted-theme">
            <div className="text-4xl mb-3">📝</div>
            <p className="text-base font-bold">Loading articles...</p>
          </div>
        )}
      </div>

      <AdBanner className="mt-6" />
    </div>
  );
}

export default Blog;
